import React, { useContext, FC } from 'react';
import { useTranslation } from 'react-i18next';
import MuiLink from '@material-ui/core/Link';
import { Typography, Box, Switch, Divider } from '@material-ui/core';
import { LabelValueProps } from './interface';
import { ProfileActionType } from '../../../types';
import { useStyles } from './styles';
import { AlertContext } from '../../shared/app/AlertProvider';
import useApi from '../../shared/hook/useApi';
import { ModalWithConfirmation } from '../../shared/modal/ModalWithConfirmation';

const LabelValue: FC<LabelValueProps> = ({
  label,
  checked,
  actionLabel,
  actionToggle,
  value,
  className,
  actionHandler,
  onToggle,
  hasDivider,
}) => {
  const { t } = useTranslation();

  const [requestCredit, setRequestCredit] = React.useState(false);
  const [requestCreditApi] = useApi('requestCreditApi');
  const { showAlert } = useContext(AlertContext);
  const classes = useStyles();

  const submitCreditRequest = () => {
    requestCreditApi().then(() => {
      showAlert({
        severity: 'success',
        message: t('v2.global.snackbar_label_creditRequestSentOut'),
      });
      setRequestCredit(false);
    });
  };

  const onActionClicked = () => {
    if (actionHandler === ProfileActionType.REQUEST_CREDIT)
      setRequestCredit(true);
  };

  return (
    <>
      <Box className={Object.values([classes.root, className]).join(' ')}>
        {label && (
          <Box className={classes.container}>
            <Typography component="p" variant="body1" className={classes.label}>
              {label}
            </Typography>
            {actionLabel && (
              <MuiLink
                component="label"
                variant="body1"
                underline="none"
                onClick={onActionClicked}
                className={classes.actionLabel}
              >
                {actionLabel}
              </MuiLink>
            )}
          </Box>
        )}
        <Box className={classes.container}>
          <Typography component="div" variant="body1">
            {value}
          </Typography>
          {actionToggle && typeof checked === 'boolean' && (
            <Switch
              color="primary"
              checked={checked}
              className={classes.actionSwitch}
              onChange={(_, checked) => {
                return onToggle && onToggle(checked);
              }}
            />
          )}
        </Box>
      </Box>
      {hasDivider && <Divider className={classes.divider} />}
      <ModalWithConfirmation
        onClose={() => setRequestCredit(false)}
        onCancel={() => setRequestCredit(false)}
        isOpen={requestCredit}
        onConfirm={submitCreditRequest}
        title={t(
          'v2.account.wallet_modal_creditSystem_requestCredits_label_title',
        )}
        text={t(
          'v2.account.wallet_modal_creditSystem_requestCredits_label_body',
        )}
        confirmBtnLabel={t(
          'v2.global.modal_creditSystem_requestCredits_button_label',
        )}
        cancelBtnlabel={t('v2.global.button_label_cancel')}
        snackbar={<></>}
      />
    </>
  );
};

export default LabelValue;
